module.exports = __webpack_public_path__ + "img/t1.21b2c158.png";